import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex items-center gap-4" }
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col text-left"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "›", -1)
const _hoisted_4 = { "aria-current": "page" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-[#163D45]"
}
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = { class: "text-md font-bold" }
const _hoisted_9 = { class: "absolute right-0 z-20 w-72 mt-2 bg-white rounded-xl shadow-md border border-gray-200/80 overflow-hidden" }
const _hoisted_10 = { class: "px-4 py-4 bg-gray-50/80 border-b border-gray-200" }
const _hoisted_11 = { class: "flex items-center gap-3" }
const _hoisted_12 = { class: "text-sm font-bold" }
const _hoisted_13 = { class: "min-w-0 text-left" }
const _hoisted_14 = { class: "text-sm font-semibold text-gray-900 truncate" }
const _hoisted_15 = { class: "text-xs text-gray-500 truncate mt-0.5" }
const _hoisted_16 = {
  key: 0,
  class: "ml-auto w-2 h-2 rounded-full bg-primary",
  "aria-label": "Novidades disponíveis",
  "data-testid": "header-changelog-unread"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "border-t border-gray-100" }, null, -1)

import { onMounted, onUnmounted, ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { mdiChevronDown, mdiAccountOutline, mdiBullhornOutline, mdiLogout } from '@mdi/js'
import LeftArrow from '@/assets/icons/rightArrow.vue'
import RigthArrow from '@/assets/icons/leftArrow.vue'
import { useCompanyStore } from '@/pinia-store/useCompanyStore'
import { useAuthStore } from '@/pinia-store/useAuthStore'
import { useUserStore } from '@/pinia-store/useUsersStore'
import { useHeaderStore } from '@/pinia-store/useHeaderStore'
import { useNotificationStore } from '@/pinia-store/useNotificationStore'
import { resolveAvatarSrc } from '@/utils/avatar'
import { usePushNotifications } from '@/hooks/usePushNotifications'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { useShellIsMobile } from '@/hooks/useShellIsMobile'
import { useChangelog } from '@/hooks/useChangelog'
import { useSidebar } from '../hooks/useSidebar'
import NotificationModal from './others/NotificationModal.vue'
import ProtectedAvatar from '@/components/designSystem/AvatarUser/ProtectedAvatar.vue'
import { useErrorToast } from '@/composables/useErrorToast'


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const companyStore = useCompanyStore()
const authStore = useAuthStore()
const userStore = useUserStore()
const headerStore = useHeaderStore()
const { notifyError } = useErrorToast()
const { myCompanies } = storeToRefs(useCompanyStore())

const dropdownOpen = ref(false)

const { hasUnread: hasUnreadChangelog, openPanel: openChangelogPanel } = useChangelog()

function openChangelog() {
  dropdownOpen.value = false
  openChangelogPanel()
}

const { isOpen, setIsOpen } = useSidebar()
const isMobile = useShellIsMobile()
// Barra de 52px (☰, título, avatar) só com a flag do celular; sem ela as classes do Header são
// exatamente as de sempre (mesma ordem). No compacto, o padding-top arbitrário com calc soma a
// safe area do topo (notch) aos 8px; pt/pb no lugar de py-2 porque o Tailwind usa
// `important: '#app'` e qualquer CSS próprio perderia para `#app .py-2`.
const { flags } = useFeatureFlags()
const isCompact = computed(() => flags.enabledDashboardMobile && isMobile.value)
const { initialize: initPush } = usePushNotifications()
const notificationStore = useNotificationStore()

function showSideBar() {
  setIsOpen(true)
}

onMounted(async () => {
  // A falha nos dados do usuário não pode abortar a carga das empresas, do push e do polling.
  try {
    await userStore.getUserData()
  } catch (error) {
    notifyError(error, 'Não foi possível carregar os seus dados.')
  }

  await companyStore.getMyCompanies()
  myCompanies.value.forEach(({ id }) => {
    companyStore.setCompanyIdsSelected({ checked: true, id })
  })

  initPush()
  notificationStore.startPolling()
})

onUnmounted(() => {
  notificationStore.stopPolling()
})

const userName = computed(() => {
  return userStore.userData?.name || 'Usuário'
})

const userEmail = computed(() => {
  return userStore.userData?.email || ''
})

const avatarUrl = computed(() => resolveAvatarSrc(userStore.userData?.avatarUrl))

const getInitalsName = (name: string) => {
  return name.substring(0, 2).toUpperCase()
}

const logout = () => authStore.logout()

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(
      isCompact.value
        ? 'flex items-center justify-between min-h-[52px] px-3 pt-[calc(0.5rem+env(safe-area-inset-top,0px))] pb-2 bg-white'
        : 'flex items-center justify-between px-8 py-4 bg-white'
    )
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(isMobile))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: showSideBar,
            class: "text-gray-500 focus:outline-none lg:block"
          }, [
            (_unref(isOpen))
              ? (_openBlock(), _createBlock(LeftArrow, { key: 0 }))
              : (_openBlock(), _createBlock(RigthArrow, { key: 1 }))
          ]))
        : _createCommentVNode("", true),
      (_unref(headerStore).title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("h1", {
              class: _normalizeClass(
            isCompact.value ? 'text-lg font-bold text-textPrimary' : 'text-2xl font-bold text-textPrimary'
          )
            }, [
              (_unref(headerStore).breadcrumbs.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headerStore).breadcrumbs, (crumb, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        _createVNode(_component_router_link, {
                          to: crumb.route,
                          class: "hover:text-primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(crumb.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _hoisted_3
                      ], 64))
                    }), 128)),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(headerStore).title), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_unref(headerStore).title), 1)
                  ], 64))
            ], 2),
            (_unref(headerStore).subtitle)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(headerStore).subtitle), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(NotificationModal),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (dropdownOpen.value = !dropdownOpen.value)),
          class: "flex relative items-center",
          "data-testid": "header-user-avatar"
        }, [
          _createVNode(_component_v_avatar, {
            color: "primary",
            class: "mr-2"
          }, {
            default: _withCtx(() => [
              _createVNode(ProtectedAvatar, {
                src: avatarUrl.value,
                size: 40
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(getInitalsName(userName.value)), 1)
                ]),
                _: 1
              }, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_icon, {
            icon: _unref(mdiChevronDown),
            size: "20",
            color: "primary",
            class: _normalizeClass(['transition-transform duration-200', { 'rotate-180': dropdownOpen.value }])
          }, null, 8, ["icon", "class"])
        ]),
        _withDirectives(_createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (dropdownOpen.value = false)),
          class: "fixed inset-0 z-10 w-full h-full"
        }, null, 512), [
          [_vShow, dropdownOpen.value]
        ]),
        _createVNode(_Transition, {
          "enter-active-class": "transition duration-150 ease-out transform",
          "enter-from-class": "scale-95 opacity-0",
          "enter-to-class": "scale-100 opacity-100",
          "leave-active-class": "transition duration-150 ease-in transform",
          "leave-from-class": "scale-100 opacity-100",
          "leave-to-class": "scale-95 opacity-0"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_v_avatar, {
                    color: "primary",
                    size: "42"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ProtectedAvatar, {
                        src: avatarUrl.value,
                        size: 42
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_12, _toDisplayString(getInitalsName(userName.value)), 1)
                        ]),
                        _: 1
                      }, 8, ["src"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("p", _hoisted_14, _toDisplayString(userName.value), 1),
                    _createElementVNode("p", _hoisted_15, _toDisplayString(userEmail.value), 1)
                  ])
                ])
              ]),
              _createVNode(_component_router_link, {
                to: "/perfil",
                "data-testid": "header-edit-profile-link",
                class: "group flex items-center gap-3 px-4 py-3.5 text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors duration-150",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (dropdownOpen.value = false))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    icon: _unref(mdiAccountOutline),
                    size: "20",
                    class: "text-gray-400 group-hover:text-primary transition-colors duration-150"
                  }, null, 8, ["icon"]),
                  _createTextVNode(" Editar Perfil ")
                ]),
                _: 1
              }),
              _createElementVNode("button", {
                type: "button",
                "data-testid": "header-changelog-button",
                class: "group flex w-full items-center gap-3 px-4 py-3.5 text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors duration-150",
                onClick: openChangelog
              }, [
                _createVNode(_component_v_icon, {
                  icon: _unref(mdiBullhornOutline),
                  size: "20",
                  class: "text-gray-400 group-hover:text-primary transition-colors duration-150"
                }, null, 8, ["icon"]),
                _createTextVNode(" Novidades "),
                (_unref(hasUnreadChangelog))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_17,
              _createElementVNode("button", {
                onClick: logout,
                "data-testid": "header-logout-btn",
                class: "group flex w-full items-center gap-3 px-4 py-3.5 text-sm font-medium text-red-500 hover:bg-red-50 hover:text-red-600 transition-colors duration-150"
              }, [
                _createVNode(_component_v_icon, {
                  icon: _unref(mdiLogout),
                  size: "20",
                  class: "text-red-400 group-hover:text-red-600 transition-colors duration-150"
                }, null, 8, ["icon"]),
                _createTextVNode(" Sair ")
              ])
            ], 512), [
              [_vShow, dropdownOpen.value]
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 2))
}
}

})